import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { invalidateLibraryManagedProductGroupFeaturedPages } from './useLibraryManagedProductGroupsFeaturePages';
import { globalErrorResponse, showNotification } from '../../../../store/notifications/actions';
import { saveLibraryManagedProductGroupSortBy } from './apiSaveLibraryManagedProductGroupSortBy';
import { useTranslation } from 'react-i18next';

type Props = {
    title: string;
    productGroupId: string;
    onSuccess: (sorting: string) => void;
};

export const useSaveLibraryManagedProductGroupSortBy = ({ productGroupId, title, onSuccess }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return useMutation((sorting: string) => saveLibraryManagedProductGroupSortBy({ productGroupId, title, sorting }), {
        onSuccess: (_data, sorting) => {
            onSuccess(sorting);

            invalidateLibraryManagedProductGroupFeaturedPages().then();

            dispatch(showNotification(t('marketing.productGroups.warnings.saveSortingOrderSuccessful')));
        },
        onError: () => {
            dispatch(globalErrorResponse(t('marketing.productGroups.warnings.saveSortingOrderError')));
        }
    });
};
